import { render, staticRenderFns } from "./NgText.vue?vue&type=template&id=1aef4a04"
import script from "./NgText.vue?vue&type=script&lang=js"
export * from "./NgText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports